<template>
  <drag-modal :visible="$store.state.dislog.Car" @cancel="reset" :title="title" width="560px">
    <div class="hisform">
      <a-form-model ref="forms" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="标的物类型">
          <a-radio-group v-model="type">
            <a-radio value="1"> 车辆 </a-radio>
            <a-radio value="2" disabled> 房产 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="车架号">
          <a-input v-model="carInfo.vin" placeholder="请输入" :disabled="see" @blur="getCarInfo" />
        </a-form-model-item>
        <a-form-model-item label="车辆品牌">
          <a-input v-model="carInfo.name" disabled />
        </a-form-model-item>
        <a-form-model-item label="排量">
          <a-input v-model="carInfo.displacement" disabled />
        </a-form-model-item>
        <a-form-model-item label="排放">
          <a-input v-model="carInfo.environmentalstandards" disabled />
        </a-form-model-item>

        <a-form-model-item label="车辆颜色" prop="color">
          <a-input maxLength="100" type="text" v-model="form.color" placeholder="请输入" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="车牌号码" prop="number">
          <a-input maxLength="10" type="text" v-model="form.number" placeholder="请输入" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="车辆登记人" prop="registrant">
          <a-input maxLength="100" type="text" v-model="form.registrant" placeholder="请输入" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="初登时间" prop="registration_time">
          <a-date-picker v-model="form.registration_time" placeholder="请选择" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
            style="width: 100%;" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="车辆估值" prop="valuation">
          <a-input type="text" maxLength="10" v-model="form.valuation" placeholder="请输入" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="估值时间" prop="valuation_time">
          <a-date-picker v-model="form.valuation_time" placeholder="请选择" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
            style="width: 100%;" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="年检时间" prop="yearly_inspection_time">
          <a-date-picker v-model="form.yearly_inspection_time" placeholder="请选择" format="YYYY-MM-DD"
            style="width: 100%;" valueFormat="YYYY-MM-DD" :disabled="see" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }" v-if="!see">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="sub">
            <a-button type="primary" style="width: 148px"> 保存 </a-button>
          </a-popconfirm>
          <a-button style="margin-left: 20px;width: 148px;background: #b2c9e1;color: #fff;" @click="reset">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>
</template>
<script>
import { getCarInfo, AddCar, EditCar } from '@/server/car.js'
export default {
  name: "Car",
  props: {
    info: {
      type: Object,
    },
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          this.see = newVal.see
          this.title = newVal.see ? '查看案涉标的物信息' : '修改案涉标的物信息'
          this.form = {
            id: newVal.id,
            debtor_id: newVal.debtor_id,
            car_info_id: newVal.car_info_id,
            color: newVal.color,
            number: newVal.number,
            registrant: newVal.registrant,
            registration_time: newVal.registration_time || '',
            valuation: newVal.valuation,
            valuation_time: newVal.valuation_time || '',
            yearly_inspection_time: newVal.yearly_inspection_time || '',
          }
          // console.log(newVal)
          if (newVal.car) {
            this.carInfo = {
              vin: newVal.car.vin,
              name: newVal.car.name,
              displacement: newVal.car.displacement,
              environmentalstandards: newVal.car.environmentalstandards,
            }
          }
        } else {
          (this.carInfo = {
            vin: '',
            name: '',
            displacement: '',
            environmentalstandards: '',
          }),
            (this.form = {})
          this.see = false
          this.title = '新增案涉标的物信息'
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      type: '1',
      carInfo: {},
      title: '新增案件沟通记录',
      form: {},
      see: false,
      visible: false,
      loading: false,
    }
  },
  methods: {
    sub() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        if (!form[val]) {
          delete form[val]
        }
      }
      if (form.debtor_id) {
        EditCar(form).then((e) => {
          this.$message.success({ content: '修改成功', key: 'updatable' })
          this.reset()
        })
      } else {
        form.debtor_id = this.$route.params.id
        AddCar(form).then((e) => {
          this.$message.success({ content: '新增成功', key: 'updatable' })
          this.reset()
        })
      }
    },
    reset() {
      this.$refs.forms.resetFields()
      this.carInfo = {}
      this.$emit('resh')
      this.$store.dispatch('openkey', { key: 'Car', by: false })
    },
    async getCarInfo() {
      if (this.carInfo.vin) {
        this.loading = true
        getCarInfo({ vin: this.carInfo.vin }).then(res => {
          this.carInfo.name = res.name
          this.carInfo.displacement = res.displacement
          this.carInfo.environmentalstandards = res.environmentalstandards
          this.form.car_info_id = res.id
          this.loading = false
        }).catch(e => {
          this.carInfo.name = ''
          this.carInfo.displacement = ''
          this.carInfo.environmentalstandards = ''
          this.form.car_info_id = ''
          this.loading = false
        })
      }
    },
  },
}
</script>
<style lang="less">
.hisform {
  textarea {
    width: 100%;
    height: 80px;
    border: 1px solid #efefef;
    padding: 4px 10px;
  }
}
</style>
